import { Breadcrumbs as BreadcrumbsComponent } from '@bridebook/web/app-basic/components/breadcrumbs/breadcrumbs.component';
import { FC, memo } from 'react';
import type { Slug } from '@bridebook/toolbox/src/types';
import { useMarket } from '@bridebook/web/app-shared/lib/i18n/hooks/use-market';
import { prettySupplierCategory } from '@bridebook/web/app-shared/lib/utils';
import { getBreadcrumbsSupplierCategory } from '@bridebook/web/app-shared/lib/utils/get-breadcrumbs-supplier-category';

interface BreadcrumbsProps {
  slug: Slug;
}

const BreadcrumbsContainer: FC<BreadcrumbsProps> = ({ slug }) => {
  const market = useMarket();
  const categoryName = slug
    ? prettySupplierCategory({
        isLoggedIn: false,
        slug,
        amount: ['venues', 'catering', 'cakes'].includes(slug) ? 2 : 1,
        addWedding: true,
        capitalize: true,
        market,
      })
    : undefined;
  const breadcrumbsData = getBreadcrumbsSupplierCategory(categoryName, slug);

  return <BreadcrumbsComponent breadcrumbsData={breadcrumbsData} center={false} showAlways />;
};

export default memo(BreadcrumbsContainer);
